

export const POST_BB_LIST = 'POST_BB_LIST';
export const POST_BB_SAVE = 'POST_BB_SAVE';
export const POST_BB_DELETE = 'POST_BB_DELETE';

export const POST_BB_COMM_LIST = 'POST_BB_COMM_LIST';
export const POST_BB_COMM_SAVE = 'POST_BB_COMM_SAVE';
export const POST_BB_COMM_DELETE= 'POST_BB_COMM_DELETE';